<template>
  <div class="similar-priced-cars" @click.stop>
    <div class="similar-priced-cars__container">
      <!-- 标题栏 -->
      <div class="similar-priced-cars__title">
        <div class="similar-priced-cars__heading">Similar Priced Cars</div>
      </div>

      <!-- 加载状态 -->
      <div v-if="loading && cars.length === 0" class="similar-priced-cars__loading">
        <div class="similar-priced-cars__loading-text">Loading...</div>
      </div>

      <!-- 错误状态 -->
      <div v-else-if="error" class="similar-priced-cars__error">
        <div class="similar-priced-cars__error-text">{{ error }}</div>
      </div>

      <!-- 无数据状态 -->
      <div v-else-if="cars.length === 0" class="similar-priced-cars__empty">
        <div class="similar-priced-cars__empty-text">No similar cars found</div>
      </div>

      <!-- 卡片容器 - PC版用flex-wrap，移动版用横向滚动 -->
      <div v-else class="similar-priced-cars__cards"
        :class="{'similar-priced-cars__cards--mobile': deviceType === 'mobile'}">
        <!-- 单个卡片 -->
        <a v-for="(car, index) in cars" :key="`car-${index}`" class="similar-priced-cars__card"
          :href="getCarDetailUrl(car)">

          <div class="all-cars__car-header">
            <div class="all-cars__brand-logo">
              <img :src="car.logo" alt="brand logo">
            </div>
            <div class="all-cars__car-info">
              <div class="all-cars__model">{{ car.model }}</div>
              <div class="all-cars__brand">{{ car.brand }}</div>
            </div>
          </div>

          <!-- 车辆图片 -->
          <img :src="car.image" class="all-cars__pic" alt="car image">

          <!-- 车辆信息 -->
          <div class="all-cars__info">
            <!-- 车辆类型 -->
            <div class="all-cars__feature">
              <img src="@/assets/calendar.svg" class="all-cars__icon" alt="year type">
              <div class="all-cars__feature-text">{{ car.year }}</div>
            </div>

            <!-- 车辆类型 -->
            <div class="all-cars__feature">
              <img src="@/assets/car-type.svg" class="all-cars__icon" alt="car type">
              <div class="all-cars__feature-text">{{ car.category }}</div>
            </div>

            <!-- 车身类型 -->
            <div class="all-cars__feature">
              <img src="@/assets/body-type.svg" class="all-cars__icon" alt="body type">
              <div class="all-cars__feature-text">{{ car.bodyType }}</div>
            </div>

            <div class="all-cars__feature">
              <img src="@/assets/homehero/Budget.svg" class="all-cars__icon" alt="Budget type">
              <div class="all-cars__feature-text">{{ car.price }}</div>
            </div>
          </div>

          <!-- 价格信息 -->
          <div class="all-cars__price">
            <div class="all-cars__price-head">Rate</div>
            <div class="all-cars__price-text">{{ car.rate || '4.8' }} <span>/ 10</span></div>
          </div>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'SimilarPricedCars',
  props: {
    carBrand: {
      type: String,
      default: ''
    },
    carCategory: {
      type: String,
      default: ''
    },
    pageNum: {
      type: Number,
      default: 1
    },
    pageSize: {
      type: Number,
      default: 8
    },
    carList: {
      type: Array,
      default: () => []
    },
    getCarDetailUrl: {
      type: Function,
      required: true
    }
  },
  computed: {
    ...mapGetters([
      'deviceType'
    ])
  },
  data () {
    return {
      cars: [],
      loading: false,
      error: null
    }
  },
  mounted () {
    // 如果提供了 carList 属性，直接使用它
    if (this.carList && this.carList.length > 0) {
      console.log('[SimilarPricedCars] 使用传入的 carList 数据:', this.carList.length);
      this.cars = this.carList;
    } else {
      // 否则通过 API 获取数据
      this.fetchSimilarCars();
    }
  },
  watch: {
    // 监听 carList 变化，更新组件数据
    carList: {
      handler (newVal) {
        if (newVal && newVal.length > 0) {
          console.log('[SimilarPricedCars] carList 更新:', newVal.length);
          this.cars = newVal;
          this.loading = false;
          this.error = null;
        }
      },
      immediate: true
    }
  },
  methods: {
    // 获取相似价格的车辆
    async fetchSimilarCars () {
      if (!this.carBrand && !this.carCategory) {
        console.warn('[SimilarPricedCars] 缺少查询参数 brand 或 category');
        return;
      }

      try {
        this.loading = true;
        this.error = null;

        // 构建API参数 - 使用props传入的分页参数
        const params = {
          pageSize: this.pageSize,
          pageNum: this.pageNum,
          total: 30  // 添加total参数，默认值为30
        };

        // 添加品牌参数(如果有)
        if (this.carBrand) {
          params.brand = this.carBrand;
        }

        // // 添加类型参数(如果有)
        // if (this.carCategory) {
        //   params.type = this.carCategory;
        // }

        console.log(`[SimilarPricedCars] 查询参数: pageNum=${this.pageNum}, pageSize=${this.pageSize}, brand=${this.carBrand}, total=30`);

        // 从store获取域名配置的主题过滤条件
        const themeFilters = this.$store.getters.domainConfig?.themeFilters || {};
        // 获取webIndex
        const webIndex = this.$store.getters.domainConfig?.webIndex || 1;

        // 合并主题过滤参数
        const requestParams = {
          ...params,
          ...themeFilters,
          webIndex
        };

        // 调用searchCar接口
        const response = await this.$global.server.searchCar(requestParams);

        if (response && response.code === 200 && response.data && response.data.list) {
          // 处理API返回的数据
          this.cars = response.data.list.map(this.formatCarData);
          console.log(`[SimilarPricedCars] 获取到相似车辆: pageNum=${this.pageNum}, count=${this.cars.length}`);
        } else {
          console.warn('[SimilarPricedCars] 获取数据失败:', response?.message || '未知错误');
          this.cars = [];
        }
      } catch (error) {
        console.error('[SimilarPricedCars] 获取相似车辆数据出错:', error);
        this.error = error.message || '获取数据失败';
        this.cars = [];
      } finally {
        this.loading = false;
      }
    },

    // 格式化车辆数据
    formatCarData (item) {
      // 格式化车辆数据以便在页面上显示
      const formattedItem = { ...item };
      formattedItem.logo = item.logoUrl || require('@/assets/car-logo.svg');

      // // 处理图片
      // if (item.photos && item.photos.length > 0) {
      //   // 如果photos是字符串（逗号分隔的URL列表），则转换为数组
      //   if (typeof item.photos === 'string') {
      //     const photoArray = item.photos.split(',');
      //     formattedItem.image = photoArray[0]; // 使用第一张图片作为主图
      //   } else {
      //     formattedItem.image = item.photos[0];
      //   }
      // } else {
      //   // 使用默认图片
      //   formattedItem.image = require('@/assets/car-recommend-img.png');
      // }

      formattedItem.image = item.cover;

      // 处理模型名称
      if (!formattedItem.model && item.name) {
        formattedItem.model = item.name;
      }

      // 确保category和bodyType有值
      formattedItem.category = item.purpose || item.type || 'N/A';
      formattedItem.bodyType = item.type || formattedItem.category || 'N/A';

      // 处理年份
      formattedItem.year = item.year || item.marketTime?.substring(0, 4) || '-';

      // 处理价格
      formattedItem.price = this.formatPrice(item.leastPrice, item.mostPrice) || item.price || '-';

      // 处理加速时间
      formattedItem.speedValue = item.accelerationTime ? `${item.accelerationTime}s` : '-';

      return formattedItem;
    },

    // 格式化价格显示
    formatPrice (leastPrice, mostPrice) {
      if (!leastPrice && !mostPrice) return null;

      const formatNumber = (num) => {
        if (!num) return null;
        // 将价格格式化为$xx,xxx格式
        return '$' + num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      };

      if (leastPrice && mostPrice) {
        // 有最低价和最高价，显示价格区间
        return `${formatNumber(leastPrice)}-${formatNumber(mostPrice)}`;
      } else if (leastPrice) {
        // 只有最低价
        return `>${formatNumber(leastPrice)}`;
      } else if (mostPrice) {
        // 只有最高价
        return `<${formatNumber(mostPrice)}`;
      }

      return null;
    },

    // 跳转到全部车辆页面
    gotoAll () {
      window.location.href = this.getAllCarsUrl();
    },
    getAllCarsUrl () {
      const currentChannel = this.$router.currentRoute.params.channel;
      const currentQuery = { ...this.$route.query };
      const queryString = Object.keys(currentQuery).length > 0
        ? `?${new URLSearchParams(currentQuery).toString()}`
        : '';
      return currentChannel ? `/${currentChannel}/car-list${queryString}` : `/car-list${queryString}`;
    }
  }
}
</script>

<style lang="scss" >
@import '~@/css/variables.scss';

.similar-priced-cars {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	align-self: stretch;
	position: relative;
	width: 100%;
	padding: rem(50) 0;

	&__container {
		display: flex;
		flex-direction: column;
		gap: rem(20);
		align-items: flex-start;
		justify-content: flex-start;
		width: 100%;
		max-width: rem(1200);
		margin: 0 auto;
		padding: 0 rem(20);
		position: relative;
	}

	&__title {
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: space-between;
		align-self: stretch;
		position: relative;
	}

	&__heading {
		color: #141414;
		font-size: rem(24);
		font-style: normal;
		font-weight: 700;
		line-height: rem(24); /* 100% */
		text-align: left;
		position: relative;
	}

	&__view {
		display: flex;
		align-items: center;
		gap: rem(10);
		cursor: pointer;
	}

	&__view-all {
		font-size: rem(16);
		line-height: rem(16);
		font-weight: 500;
		color: #405ff2;
	}

	&__icon {
		flex-shrink: 0;
		width: rem(14);
		height: rem(14);
		position: relative;
		overflow: visible;
	}

	&__cards {
		display: flex;
		flex-wrap: wrap;
		gap: rem(20);
		align-self: stretch;
		width: 100%;
		min-height: rem(300);

		// 移动端横向滚动样式
		&--mobile {
			flex-wrap: nowrap;
			overflow-x: auto;
			scrollbar-width: none; /* Firefox */
			-ms-overflow-style: none; /* IE and Edge */
			padding-bottom: rem(10);

			&::-webkit-scrollbar {
				display: none; /* Chrome, Safari, Opera */
			}
		}
	}

	&__card {
		// width: calc(33.33% - rem(14));
		flex: 0 0 calc((100% - rem(60)) / 4); /* 使每个子元素占1/4的宽度 */
		border-radius: rem(12);
		background: #fff;
		overflow: hidden;
		border: 1px solid #e9e9e9;
		cursor: pointer;
		transition: transform 0.3s ease;
		background: linear-gradient(180deg, rgba(255, 255, 255, 0.08) 0%, rgba(255, 255, 255, 0.08) 50%, rgba(var(--theme-color-r), var(--theme-color-g), var(--theme-color-b), 0.08) 100%);
		padding: rem(20);

		&:hover {
			transform: translateY(-4px);
		}

		// 移动端卡片样式
		.similar-priced-cars__cards--mobile & {
			width: rem(280);
			flex: 0 0 auto;
		}
	}

	&__image-container {
		width: 100%;
		height: rem(180);
		position: relative;
		overflow: hidden;
	}

	&__pic {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}

	&__speed-tag {
		position: absolute;
		top: rem(6);
		left: rem(6);
		z-index: 2;
		display: flex;
		background: rgba(0, 0, 0, 0.5);
		border-radius: rem(8);
		overflow: hidden;
	}

	&__speed-value {
		background: rgba(0, 0, 0, 0.5);
		padding: rem(4) rem(8);
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: center;
	}

	&__speed-number {
		color: #ffffff;
		text-align: center;
		font-size: rem(12);
		line-height: rem(12);
		font-weight: 700;
	}

	&__speed-label {
		padding: rem(4) rem(8);
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: center;
	}

	&__speed-text {
		color: #ffffff;
		text-align: center;
		font-size: rem(10);
		line-height: rem(10);
		font-weight: 400;
	}

	&__baseinfo {
		background: rgba(255, 255, 255, 0.5);
		backdrop-filter: blur(10px);
		border-radius: rem(12);
		padding: rem(16);
		display: flex;
		flex-direction: column;
		gap: rem(10);
		align-items: flex-start;
		justify-content: flex-start;
		width: 100%;
		z-index: 2;
	}

	&__info {
		display: flex;
		flex-direction: column;
		gap: rem(16);
		align-items: flex-start;
		justify-content: flex-start;
		align-self: stretch;
		flex-shrink: 0;
		position: relative;
	}

	&__card-title {
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: space-between;
		align-self: stretch;
		flex-shrink: 0;
		position: relative;
	}

	&__name {
		display: flex;
		flex-direction: column;
		gap: rem(8);
		align-items: flex-start;
		justify-content: flex-start;
		position: relative;
	}

	&__model {
		color: #050b20;
		font-size: rem(16);
		font-style: normal;
		font-weight: 700;
		line-height: 100%; /* 16px */
		margin-bottom: rem(4);
		display: flex;
		align-items: center;
		justify-content: flex-start;
		overflow: hidden;
		display: -webkit-box;
		text-overflow: ellipsis;
		-webkit-line-clamp: 1;
		-webkit-box-orient: vertical;
	}

	&__brand {
		color: #848998;
		font-size: rem(12);
		font-style: normal;
		font-weight: 400;
		line-height: 100%; /* 12px */
		display: flex;
		align-items: center;
		justify-content: flex-start;
	}

	&__logo {
		width: rem(36);
		height: rem(36);
		background: #fff;
		border-radius: 50%;
		padding: rem(2);
		object-fit: contain;
	}

	&__divider {
		background: #050b20;
		opacity: 0.1;
		align-self: stretch;
		flex-shrink: 0;
		height: rem(1);
		position: relative;
	}

	&__type {
		display: flex;
		flex-direction: column;
		gap: rem(8);
		align-items: flex-start;
		justify-content: flex-start;
		align-self: stretch;
		flex-shrink: 0;
		position: relative;
	}

	&__type-item {
		display: flex;
		flex-direction: row;
		gap: rem(9);
		align-items: center;
		justify-content: flex-start;
		flex-shrink: 0;
		position: relative;
	}

	&__type-icon {
		flex-shrink: 0;
		width: rem(12);
		height: rem(12);
		position: relative;
	}

	&__type-text {
		color: #050b20;
		text-align: left;
		font-size: rem(12);
		line-height: rem(12);
		font-weight: 400;
		position: relative;
		display: flex;
		align-items: center;
		justify-content: flex-start;
	}

	&__price {
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: space-between;
		align-self: stretch;
		flex-shrink: 0;
		position: relative;
		color: var(--theme-color);
	}

	&__price-amount {
		color: #050b20;
		text-align: left;
		font-size: rem(18);
		line-height: rem(18);
		font-weight: 700;
		position: relative;
		display: flex;
		align-items: center;
		justify-content: flex-start;
	}

	&__price-link {
		border-radius: rem(50%);
		width: rem(16);
		height: rem(16);
		position: relative;
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;

		img {
			flex-shrink: 0;
			width: rem(16);
			height: rem(16);
			position: relative;
			overflow: visible;
		}
	}

	&__loading {
		display: flex;
		justify-content: center;
		align-items: center;
		height: rem(200);
	}

	&__loading-text {
		font-size: rem(16);
		font-weight: 500;
		color: #405ff2;
	}

	&__error {
		display: flex;
		justify-content: center;
		align-items: center;
		height: rem(200);
	}

	&__error-text {
		font-size: rem(16);
		font-weight: 500;
		color: #ff0000;
	}

	&__empty {
		display: flex;
		justify-content: center;
		align-items: center;
		height: rem(200);
	}

	&__empty-text {
		font-size: rem(16);
		font-weight: 500;
		color: #4c5164;
	}
}

// all-cars样式部分 - 用于卡片展示
.all-cars {
	&__car-header {
		display: flex;
		align-items: center;
		gap: rem(20);
		margin-bottom: rem(20);
	}

	&__brand-logo {
		width: rem(40);
		height: rem(40);
		display: flex;
		align-items: center;
		justify-content: center;
		background: #ffffff;
		border-radius: 50%;
		border-radius: 100px;
		border: 1px solid #e9e9e9;
		background: lightgray 50% / cover no-repeat, #fff;

		img {
			width: rem(40);
			height: rem(40);
			object-fit: contain;
		}
	}

	&__car-info {
		display: flex;
		flex-direction: column;
		gap: rem(8);
	}

	&__model {
		font-size: rem(16);
		font-weight: 600;
		line-height: rem(16); /* 100% */
		color: #141414;
	}

	&__brand {
		font-size: rem(12);
		line-height: rem(12); /* 100% */
		color: #777777;
	}

	&__pic {
		width: rem(280);
		height: rem(164);
		object-fit: cover;
		border-radius: rem(16);
		border: rem(1) solid #fff;
		background: lightgray 50% / cover no-repeat;
	}

	&__info {
		padding: rem(12) 0;
		display: flex;
		flex-direction: column;
		gap: rem(8);
	}

	&__feature {
		display: flex;
		align-items: center;
		gap: rem(10);
	}

	&__icon {
		width: rem(16);
		height: rem(16);
	}

	&__feature-text {
		font-size: rem(14);
		color: #141414;
	}

	&__price {
		padding: rem(16) 0 0;
		border-top: 2px solid #fff;
		display: flex;
		align-items: center;
		justify-content: flex-start;
		gap: rem(20);
	}

	&__price-head {
		color: #777;
		text-align: center;
		font-size: rem(12);
		font-style: normal;
		font-weight: 400;
		line-height: rem(12);
	}

	&__price-text {
		color: var(--theme-color);
		text-align: center;
		font-size: rem(18);
		font-style: normal;
		font-weight: 700;
		line-height: rem(20);
		span {
			color: #141414;
			font-size: rem(12);
			font-style: normal;
			font-weight: 700;
			line-height: rem(20);
		}
	}
}

// 响应式样式 - PC设备
.detect_deviece_pc,
.detect_deviece_desktop {
	.similar-priced-cars {
		--fontsize-base: #{$vw_fontsize_pc};
		font-size: calc(var(--fontsize-base) / #{$vw_design_pc} * 100vw);
		padding: rem(50) 0;
	}
}

// 响应式样式 - 移动设备
.detect_deviece_mobile {
	.similar-priced-cars {
		--fontsize-base: #{$vw_fontsize_mobile};
		font-size: calc(var(--fontsize-base) / #{$vw_design_mobile} * 100vw);
		padding: rem(30) rem(16);

		&__container {
			padding: 0 rem(16);
		}

		&__heading {
			font-size: rem(20);
		}

		&__card {
			width: rem(260);
		}

		&__view-all {
			font-size: rem(14);
			line-height: rem(14);
		}

		&__icon {
			width: rem(14);
			height: rem(14);
		}
	}
}
</style>
